// extracted by mini-css-extract-plugin
export default {"content":"no-auth_content__+S1gq","img":"no-auth_img__ME8qE","text":"no-auth_text__fTCxS","button":"no-auth_button__eeV+B","name":"no-auth_name__2327I"};